var path = 'scripts/views/components/reallocate-transactions-button.html';
var html = "<button class=\"reallocate-transactions-btn btn-primary btn mls action-button hidden-xs hidden-sm hidden-md\"\n        ng-click=\"$ctrl.onClick()\"\n        ng-if=\"$ctrl.showButton()\"\n        ng-disabled=\"$ctrl.isDisabled()\"\n        analytics-on=\"click\"\n        analytics-properties=\"{eventAsset:'Reallocate Transaction',tab:'transactionTab'}\">\n        <span translate>transactions.ReallocateTransactionsButton</span>\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/reallocate-transactions-button.html
// module id = 334
// module chunks = 0